"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    margin-bottom: ", "em;\n    padding-top: ", "em;\n"], ["\n    color: ", ";\n    background-color: ", ";\n    margin-bottom: ", "em;\n    padding-top: ", "em;\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../functions");

var _theme = require("../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var background = function background(props) {
    return _theme.colors[props.type] || _theme.colors[props.theme.panel.default];
};

var Panel = _styledComponents2.default.div(_templateObject, function (props) {
    return (0, _functions.foregroundColor)(background(props), 0.5, props.theme.lightColor, props.theme.darkColor);
}, function (props) {
    return background(props);
}, function (props) {
    return props.margin != undefined ? props.margin : _theme.spacing.margin;
}, function (props) {
    return props.padding != undefined ? props.padding : _theme.spacing.padding;
});

Panel.displayName = "Panel";

Panel.propTypes = _defineProperty({
    type: _propTypes2.default.string,
    marginBottom: _propTypes2.default.number,
    padding: _propTypes2.default.number,
    margin: _propTypes2.default.number
}, "padding", _propTypes2.default.number);

Panel.defaultProps = {};

exports.default = Panel;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/panel.js
// module id = 453
// module chunks = 95715928098905 168707334958949